import script from "./MainPage_CHS.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainPage_CHS.vue?vue&type=script&setup=true&lang=ts"

import "./MainPage_CHS.vue?vue&type=style&index=0&id=9bf017e8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bf017e8"]])

export default __exports__